import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { fmt } from "../../lib/api";
import SectionCard from "./SectionCard";
import {
  Select, SelectTrigger, SelectContent, SelectItem, SelectValue,
} from "../ui/select";

const AYLAR = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran",
               "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];

export default function Kategori6({ factors, data, setData, results }) {
  const setVal = (k, v) => setData((d) => ({ ...d, [k]: v }));
  const setAylik = (ay, v) => setData((d) => ({ ...d, aylik: { ...(d.aylik || {}), [ay]: v } }));

  const kaynak = factors.kaynaklar.find((k) => k.id === data.kaynak_id) || factors.kaynaklar[0];

  return (
    <div className="space-y-6 animate-fadeInUp">
      <div>
        <div className="text-[11px] uppercase tracking-[0.2em] text-muted-foreground mb-1">Kategori 6</div>
        <h2 className="font-display text-3xl font-semibold">Diğer Dolaylı Emisyonlar</h2>
        <p className="text-muted-foreground mt-1 text-sm max-w-2xl">
          Elektrik iletim ve dağıtım kayıplarından kaynaklanan kayıp-kaçak emisyonlar.
        </p>
      </div>

      <SectionCard title="Elektrik İletim / Dağıtım Kayıpları" total={results?.total}>
        <div className="grid md:grid-cols-2 gap-4 mb-5">
          <div>
            <Label className="text-sm font-medium mb-1.5 block">Şebeke</Label>
            <Select value={data.kaynak_id} onValueChange={(v) => setVal("kaynak_id", v)}>
              <SelectTrigger data-testid="k6-kaynak-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                {factors.kaynaklar.map((k) => (
                  <SelectItem key={k.id} value={k.id}>{k.label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
            <div className="text-[11px] text-muted-foreground mt-1.5">
              EF: {fmt(kaynak.ef, 4)} kg CO₂e/kWh · {kaynak.kaynak}
            </div>
          </div>
          <div>
            <Label className="text-sm font-medium mb-1.5 block">Yıllık Kayıp-Kaçak Miktarı (kWh)</Label>
            <Input type="number" step="any" value={data.yillik || ""}
                   onChange={(e) => setVal("yillik", e.target.value)}
                   placeholder="Ör: 598.77" data-testid="k6-yillik" />
          </div>
        </div>
        <div>
          <Label className="text-sm font-medium mb-3 block">Aylık Detay (isteğe bağlı)</Label>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
            {AYLAR.map((ay) => (
              <div key={ay}>
                <div className="text-[11px] text-muted-foreground mb-1">{ay}</div>
                <Input type="number" step="any" value={data.aylik?.[ay] || ""}
                       onChange={(e) => setAylik(ay, e.target.value)}
                       placeholder="kWh" className="h-9" data-testid={`k6-ay-${ay}`} />
              </div>
            ))}
          </div>
        </div>
      </SectionCard>
    </div>
  );
}
